var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.475 20.15L13.225 13.9C12.725 14.3167 12.15 14.6417 11.5 14.875C10.85 15.1084 10.2 15.225 9.55005 15.225C7.93338 15.225 6.57105 14.6707 5.46305 13.562C4.35438 12.454 3.80005 11.1 3.80005 9.50002C3.80005 7.90002 4.35438 6.54569 5.46305 5.43702C6.57105 4.32902 7.92505 3.77502 9.52505 3.77502C11.125 3.77502 12.4834 4.32902 13.6 5.43702C14.7167 6.54569 15.275 7.90002 15.275 9.50002C15.275 10.2 15.15 10.875 14.9 11.525C14.65 12.175 14.325 12.725 13.925 13.175L20.2001 19.45L19.475 20.15ZM9.55005 14.225C10.8667 14.225 11.9834 13.771 12.9 12.863C13.8167 11.9544 14.275 10.8334 14.275 9.50002C14.275 8.16669 13.8167 7.04569 12.9 6.13702C11.9834 5.22902 10.8667 4.77502 9.55005 4.77502C8.21672 4.77502 7.09172 5.22902 6.17505 6.13702C5.25838 7.04569 4.80005 8.16669 4.80005 9.50002C4.80005 10.8334 5.25838 11.9544 6.17505 12.863C7.09172 13.771 8.21672 14.225 9.55005 14.225Z",
    fill: "#15B79E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.8535fcb5252bb24855658f911ad883d0.svg";
export { ForwardRef as ReactComponent };